module.exports = __webpack_public_path__ + "img/alphatauri.d55dee38.png";